module.exports = __webpack_public_path__ + "static/media/Isabella.3621898f.jpg";